import * as ServiceCustomer from '../services/customers';
import Vue from 'vue';
import store from '../store';
import i18n from '../translations'

export default {
    namespaced: true,
    state: {
        customer: {},
    },
    actions: {
        async getCustomers(context) {
            let serviceman = context.rootState.auth.user.serviceman;
            let response = await ServiceCustomer.getCustomers(serviceman);
            if (response.data) {
                context.commit('setCustomer', response.data.customerByUser.allCustomersData[0]);
            } else {
                console.log(response)
            }
        },

        async getCurrentCustomer(context) {
            let cardCode = context.rootState.auth.user.cardCode;
            let response = await ServiceCustomer.getCustomers('', cardCode);
            if (response.data) {
              context.commit('setCustomer', response.data.customerByUser.allCustomersData[0]);
              store.commit('cart/setCustomerData',response.data.customerByUser.allCustomersData[0]);
              store.commit('auth/setPaymentCustomer',response.data.customerByUser.allCustomersData[0].defaultPayment);
            } else {
              console.log(response)
            }
            return [];
          },
        async updateCustomerShipping(context, data) {
            let cardCode = context.rootState.auth.user.cardCode;
            let customerId = context.rootState.customers.customer.customerId;
            let response = await ServiceCustomer.setAddressForm(data,cardCode,customerId);
            if (response.data) {
                Vue.notify({
                    group: 'success',
                    title: `${ i18n.t('customer.addressUpdated')}`,
                    text: ""
                });
                context.commit('updateCustomerShipping', data);
            } else {
                console.log(response);
            }
        },
        async addCustomerShipping(context, data) {
            let cardCode = context.rootState.auth.user.cardCode;
            let customerId = context.rootState.customers.customer.customerId;
            let response = await ServiceCustomer.setAddressForm(data, cardCode,customerId);
            if (response.data) {
                if(response.data.addressFormSubmit.shipping[0].response === "error"){
                    Vue.notify({
                        group: 'error',
                        title: `${ i18n.t('customer.addressNotAdded')}`,
                        text: ""
                    });
                    throw new Error();
                }else{
                    Vue.notify({
                        group: 'success',
                        title: `${ i18n.t('customer.addressAdded')}`,
                        text: ""
                    });
                    context.commit('addCustomerShipping', response.data.addressFormSubmit.shipping[0]);
                }
            } else {
                console.log(response);
            }
        }
    },
    getters: {
        shipping:  (state) => {
            return state.customer.shipping;
        },
        billing: (state) => {
            return  state.customer.billing;
        },
    },
    mutations: {
        setCustomer(state, customer) {
           state.customer = customer;
        },
        updateCustomerShipping(state, data) {
            let updatedShipping = state.customer.shipping.find(shipping => shipping.addressId === data.addressId);
            // We ensure that we don't add new keys and update only existing
            Object.keys(updatedShipping).forEach(key => {
                if (data[key] !== undefined) {
                    updatedShipping[key] = data[key];
                }
            });
        },
        addCustomerShipping(state, data) {
            state.customer.shipping.push(data);
        }
    },
}
